import { forwardRef } from 'react'
import { NumericInputProps } from './NumericInput.types'
import {
  Container,
  InputWrapper,
  Prefix,
  Suffix,
  Input,
} from './NumericInput.styles'

export const NumericInput = forwardRef<HTMLInputElement, NumericInputProps>(
  (
    {
      value,
      onChange,
      placeholder,
      prefix,
      suffix,
      disabled = false,
      min,
      max,
      step = 1,
      type = 'number',
      allowDecimals = false,
      className,
      style,
      autoFocus = false,
      readOnly = false,
      id,
      name,
      'aria-label': ariaLabel,
    },
    ref
  ) => {
    const hasPrefix = !!prefix
    const hasSuffix = !!suffix

    return (
      <Container className={className} style={style}>
        <InputWrapper $disabled={disabled}>
          {hasPrefix && <Prefix>{prefix as any}</Prefix>}
          <Input
            ref={ref}
            type={type}
            value={value ?? ''}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            min={min}
            max={max}
            step={allowDecimals ? step : 1}
            $hasPrefix={hasPrefix}
            $hasSuffix={hasSuffix}
            $disabled={disabled}
            autoFocus={autoFocus}
            readOnly={readOnly}
            id={id}
            name={name}
            aria-label={ariaLabel}
          />
          {hasSuffix && <Suffix>{suffix as any}</Suffix>}
        </InputWrapper>
      </Container>
    )
  }
)

NumericInput.displayName = 'NumericInput'
